import React, { useState,useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/Modal';
import CoursewareSelector from './CoursewareSelector';
import { STEPS } from './constants';

function CourseSelectorModal({
  onDismiss,
  visible,
  onPrimaryHandler,
  postActivitySelectView,
  primaryButtonText,
  selectWorkspaceOnly,
  showSelectedWorkspace,
}) {

  const ancestorArray = [
    {
      elementId: showSelectedWorkspace ? 'workspace' : 'main',
      elementType: showSelectedWorkspace ? STEPS.WORKSPACE : STEPS.MAIN,
    },
  ];
  const [ancestorsForCourseware, setAncestorsForCourseware] = useState(ancestorArray);
  const [showPostActivitySelectFlow, setShowPostActivitySelectFlow] = useState(false);

  const DEFAULT_SELECTOR = {
    id: null,
    type: showSelectedWorkspace ? STEPS.WORKSPACE : STEPS.MAIN,
  };

  const [selectorData, setSelectorData] = useState(DEFAULT_SELECTOR);

  useEffect(()=>{
    if(!visible){
      init();
    }
  },[visible,init]);

  const handleOnDismiss = () => {
    onDismiss();
    init();
  };

  const init = useCallback(() => {
    setShowPostActivitySelectFlow(false);
    setSelectorData(DEFAULT_SELECTOR);
  },[DEFAULT_SELECTOR]);

  const onNext = (newSelector) => {
    setSelectorData({
      id: newSelector.id,
      type: newSelector.type,
    });

    setAncestorsForCourseware([
      ...ancestorsForCourseware,
      {
        elementId: newSelector.id,
        elementType: newSelector.type,
      },
    ]);
  };

  const onBack = () => {
    const currentSelectorIndex = ancestorsForCourseware.findIndex(
      (ancestor) => selectorData.id === ancestor.elementId
    );

    if (currentSelectorIndex === 0) return;
    const parentSelector = ancestorsForCourseware[currentSelectorIndex - 1];
    // remove the last node;
    setAncestorsForCourseware(ancestorsForCourseware.slice(0, -1));
    setSelectorData({
      id: parentSelector.elementId,
      type: parentSelector.elementType,
    });
  };

  const onSelectPrimary = (activityObject) => {
    onPrimaryHandler(activityObject);
    if (postActivitySelectView) {
      setShowPostActivitySelectFlow(true);
    }
  };
  
  return (
    <Modal visible={visible} onDismiss={handleOnDismiss}>
      {!showPostActivitySelectFlow && <CoursewareSelector
        selector={selectorData}
        onBack={onBack}
        onNext={onNext}
        onDismiss={handleOnDismiss}
        primaryHandler={onSelectPrimary}
        primaryButtonText={primaryButtonText}
        selectWorkspaceOnly={selectWorkspaceOnly}
        showSelectedWorkspace={showSelectedWorkspace}
      />}
      {showPostActivitySelectFlow && postActivitySelectView}
    </Modal>
  );
}

CourseSelectorModal.propTypes = {
  onDismiss: PropTypes.func,
  visible: PropTypes.bool,
  onPrimaryHandler: PropTypes.func,
  postActivitySelectView: PropTypes.object,
  primaryButtonText: PropTypes.string,
  selectWorkspaceOnly: PropTypes.bool,
  showSelectedWorkspace:PropTypes.bool,
};

export default CourseSelectorModal;
